import * as React from "react";
import { useForm } from "../../../../../hooks/use_form_v2";
import { Form } from "../../../../Components/Form/Form/Form";
import { AutomationType, PaymentMethodAutomationAction, paymetMethodAutomationOptions } from "../../../../../config/automation";
import { SelectField } from "../../../../Components/Form/SelectField";
import { SubFormContainer } from "../../Components/SubFormContainer";
import { PaymentMethodField } from "../../../../Transactions/Components/Form/Fields/PaymentMethodField";
import { ShareWithFriends } from "./ShareWithFriends";
import { AutomationsValidationErrors } from "../../../../../validators/automations";

interface IUserPaymentMethodFormProps {
    value: any;
    onChange(v: IAutomationFormState): void;
    errors?: AutomationsValidationErrors;
}

export interface IAutomationFormState {
    type: AutomationType.PAYMENT_METHOD;
    paymentMethodId: number;
    action: PaymentMethodAutomationAction;
    payload: any;
}

export const UserPaymentMethodForm = ({onChange, value, errors}: IUserPaymentMethodFormProps) => {
    const form = useForm<IAutomationFormState>(value || {}, {prevFormErrors: errors});
    const { register, watch, getValues } = form;

    React.useEffect(() => {
        onChange(getValues());
    }, [getValues()]);

    const handelSubmit = (values: IAutomationFormState) => {
        return Promise.resolve();
    };

    return (
        <SubFormContainer>
            <Form form={form} onSubmit={handelSubmit} withSubmitButton={false} component="div">
                <Form.Field type={PaymentMethodField} {...register('paymentMethodId')} />

                <Form.Field
                    type={SelectField}
                    {...register('action')}
                    options={paymetMethodAutomationOptions}
                />

                <Form.Field
                    type={ShareWithFriends}
                    {...register('payload')}
                    splitType={watch('action')}
                    errors={errors}
                    conditional={watch('action') === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE || watch('action') === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED}
                    noWrapper
                />
            </Form>
        </SubFormContainer>
    );
}
